<template>
  <div>
    <b-form-spinbutton min="1" max="12" v-model="selected">4</b-form-spinbutton>
    <span>{{ selected }}</span>
    <b-tabs v-model="tabIndex">
      <b-tab v-for="m of meses" :key="m.id" :title="m.red"></b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  name: "tabMeses",

  props: {
    value: {
      type: Number,
      default: new Date().getMonth() + 1,
    },
  },

  data() {
    return {
      meses: [
        { id: 1, red: "Jan", nome: "Janeiro" },
        { id: 2, red: "Fev", nome: "Fevereiro" },
        { id: 3, red: "Mar", nome: "Março" },
        { id: 4, red: "Abr", nome: "Abril" },
        { id: 5, red: "Mai", nome: "Maio" },
        { id: 6, red: "Jun", nome: "Junho" },
        { id: 7, red: "Jul", nome: "Julho" },
        { id: 8, red: "Ago", nome: "Agosto" },
        { id: 9, red: "Set", nome: "Setembro" },
        { id: 10, red: "Out", nome: "Outubro" },
        { id: 11, red: "Nov", nome: "Novembro" },
        { id: 12, red: "Dez", nome: "Desembro" },
      ],
      selected: this.value || new Date().getMonth() + 1,
    };
  },

  computed: {
    tabIndex: {
      get() {
        return this.selected - 1;
      },
      set(value) {
        this.selected = value + 1;
      },
    },
  },

  watch: {
    selected(mes) {
      this.$emit("input", mes);
    },
  },
};
</script>
